import { render, staticRenderFns } from "./CamposDeProdutoPadrao.vue?vue&type=template&id=0f123dae&"
import script from "./CamposDeProdutoPadrao.vue?vue&type=script&lang=ts&"
export * from "./CamposDeProdutoPadrao.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports